import { render } from "./DuprClub.vue?vue&type=template&id=1dde10b0"
import script from "./DuprClub.vue?vue&type=script&lang=js"
export * from "./DuprClub.vue?vue&type=script&lang=js"

import "./DuprClub.vue?vue&type=style&index=0&id=1dde10b0&lang=css"

import exportComponent from "D:\\AlterLau\\walter-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__